// 客户端首页

import React, { useState, useEffect, useRef } from 'react'
import { message, Form, Input, Button, Modal, Carousel, Dropdown, Drawer, notification } from 'antd'
import fun from '../../common/common_fun'
import url from '../../common/url_config'
import { UserOutlined, LockOutlined, UnorderedListOutlined } from '@ant-design/icons';
import cookie from 'react-cookies'
import FadeInImg from './fade_in_img.jsx'
import FadeInImgQues from './fade_in_img_ques.jsx'
import experience_1 from '../../img/icon1.jpg'
import experience_2 from '../../img/icon2.jpg'
import experience_3 from '../../img/icon3.jpg'
import experience_4 from '../../img/icon4.jpg'
import experience_5 from '../../img/icon5.jpg'
import experience_6 from '../../img/icon6.png'
import experience_7 from '../../img/icon7.jpg'
import common_data from '../../common/common_data';

const Context = React.createContext({
  name: 'Default',
});

function App(props: any) {
  const videoRef = useRef(null)
  let [is_auto_play, set_is_auto_play] = useState(true)
  let [loading, set_loading] = useState(false)//加载中
  let [current_language_ch, set_current_language_ch] = useState(window.location.href.indexOf('?lan=en') === -1)//当前语言是否中文

  let experience_set = [
    {
      name_ch: '硬件',
      name_en: 'NXP Hardware',
      remarks_ch: '用户可以远程预订、调试、评估和测试恩智浦产品',
      remarks_en: 'Users can remotely book, debug, evaluate and test NXP products.',
      img: experience_2,
      href: '/product/overview'
    },
    {
      name_ch: '软件',
      name_en: 'NXP Software',
      remarks_ch: '用户可以远程预定、调试、评估和测试恩智浦的软件产品',
      remarks_en: 'Users can remotely book, debug, evaluate and test NXP software products.',
      img: experience_3,
      href: '/software'
    },
    {
      name_ch: '系统方案',
      name_en: 'Solution',
      remarks_ch: '基于用户实际用例的系统解决方案体验',
      remarks_en: "Experience optimized solutions based on customers' user guides.",
      img: experience_4,
      href: '/solution'
    },
    {
      name_ch: '应用范例',
      name_en: 'User Guide',
      remarks_ch: '用户远程观看和体验恩智浦所设计的应用范例',
      remarks_en: 'Remotely watch the latest NXP demos and POC solutions based on customer user guides.',
      img: experience_5,
      href: '/use-case'
    },
    {
      name_ch: '全国大学生智能汽车竞赛视觉组体验',
      name_en: 'Hardware Experience Zone for the Vision Group of Smart Car Race',
      remarks_ch: '用户可以在线体验视觉组相关硬件',
      remarks_en: 'Online debug with the hardware for the vision group',
      img: experience_6,
      href: '/smartcar-vision'
    },
    // {
    //   name_ch: '学习园地',
    //   name_en: 'Learning resources',
    //   remarks_ch: '学习园地',
    //   remarks_en: 'Learning resources',
    //   img: experience_6,
    //   href: '/developing'
    // },
    // {
    //   name_ch: '关于我们',
    //   name_en: 'About us',
    //   remarks_ch: '关于我们',
    //   remarks_en: 'About us',
    //   img: experience_7,
    //   href: '/developing'
    // },
  ]

  useEffect(() => {
    const videoElement: any = videoRef.current;
    if (videoElement) {
      videoElement.addEventListener('play', () => {
        console.log('Video is playing');
        set_is_auto_play(false)
      });
    }

    setTimeout(() => {
      let temp = document.getElementsByClassName('index_page_box')
      console.log(temp[0])
    }, 1000 * 3)
  }, [])

  let title_style: any = { width: '94%', margin: '0 auto', maxWidth: 1300, color: '#000000', fontSize: common_data.isMobile ? 30 : 40, fontWeight: 'bold', paddingTop: 15, fontFamily: 'PoppinsBold', }
  let main_width_style: any = { width: '94%', margin: '0 auto', maxWidth: 1300 }

  return (
    <div style={{}} className='main_index_show index_page_box'>
      <div style={{ backgroundColor: '#ffffff', }}>
        {/* Overview */}
        <div>
          <Carousel autoplay={true} infinite={true}>
            {/* 第一屏 */}
            <div>
              <div style={{ position: 'relative' }} className='fade_banner_img_pc'>
                <img style={{ width: '100%', height: 'auto' }} src={url + 'static/banner/banner_top.jpg'} />
                <FadeInImgQues />
              </div>
              <div style={{ position: 'relative' }} className='fade_banner_img_mobile'>
                <img style={{ width: '100%', height: 'auto' }} src={url + 'static/banner/banner_top_mob.jpg'} />
                <FadeInImgQues />
              </div>
            </div>

            {/* 第二屏 */}
            <div>
              <div style={{ position: 'relative' }} className='fade_banner_img_pc'>
                <img style={{ width: '100%', height: 'auto' }} src={url + 'static/banner/banner_top.jpg'} />
                <FadeInImg />
              </div>
              <div style={{ position: 'relative' }} className='fade_banner_img_mobile'>
                <img style={{ width: '100%', height: 'auto' }} src={url + 'static/banner/banner_top_mob.jpg'} />
                <FadeInImg />
              </div>
            </div>
          </Carousel>
        </div>
        <div style={{ height: 30 }}></div>
        {/* 测试 */}
        {/* <p>首页测试canvas</p>
        <iframe style={{ width: '100%', minHeight: 660, height: 100 }} allow='microphone *;camera *' src={'https://uat.aiotcloud.nxp.com.cn/ai_canvas_back.html'}></iframe> */}

        <div style={title_style}>{current_language_ch ? '恩智浦云实验室' : 'Overview'}</div>
        <div className='overview_box' style={{ alignItems: 'center', justifyContent: 'space-between', ...main_width_style }}>
          <div className='overview_left' style={{ fontSize: 16, textAlign: 'justify', color: '#000000' }}>
            {current_language_ch ? <>
              <div>云实验室是恩智浦全球首个对外开放的全线上实验室。我们的愿景是为通过网络为用户提供探索恩智浦最新硬件、软件和解决方案的平台。</div>
              <div>用户通过简单的网页操作便可实时和恩智浦的最新产品与解决方案进行互动，并支持在线远程调试、评估、更新代码、自动测试及软件性能的体验等，同时我们在云实验室里对用户提供实时和专业的技术支持。</div>
              <div>在您通往星辰大海的路上，恩智浦云实验室愿做您的创新点子的新沃土，在这里，我们将和您一起成长。</div>
              <div>来，让我们开启云实验室的大门，解锁无限之可能。</div>
            </> : <>
              <div>The Cloud Lab is NXP's first global online laboratory. Our vision is to allow users to explore the latest NXP hardware, software and solutions in an online environment. The Cloud Lab is an online service that allows for code debugging and technical evaluation on remotely accessed development boards, software and solutions. In addition, users can also watch the latest demos of NXP products.</div>
              <div>The Cloud Lab is a new fertile ground for developers around the world, where you can test your ideas on new hardware platforms, experience changes brought about by the latest NXP technology and solve problems with expert insights from NXP engineers.</div>
              <div>Are you ready to explore The Cloud Lab and unlock your potential?</div>
            </>}
          </div>
          <div className='overview_right' style={{}}>
            <Carousel dotPosition='top' autoplay={is_auto_play} infinite={true}>
              <div>{current_language_ch ?
                <video ref={videoRef} controls poster={url + 'static/video/poster_ch.jpg'} style={{ width: '100%' }} src={url + 'static/video/video_ch.mp4'} /> :
                <video ref={videoRef} controls poster={url + 'static/video/poster_en.jpg'} style={{ width: '100%' }} src={url + 'static/video/video_en.mp4'} />}
              </div>
              <img style={{ width: '100%', height: 'auto' }} src={url + 'static/banner/1.jpg'} />
              <img style={{ width: '100%', height: 'auto' }} src={url + 'static/banner/2.jpg'} />
              <img style={{ width: '100%', height: 'auto' }} src={url + 'static/banner/3.jpg'} />
              <img style={{ width: '100%', height: 'auto' }} src={url + 'static/banner/4.jpg'} />
            </Carousel>
          </div>
        </div>

        {/* Experience  */}
        <div style={{ backgroundColor: "#F7F5F1", paddingTop: 20, paddingBottom: 40, marginTop: 50 }}>
          <div style={{ ...title_style, marginTop: 0 }}>{current_language_ch ? '探索恩智浦云实验室' : 'Experience The Cloud Lab'}</div>
          <div style={{ ...main_width_style, }}>
            {experience_set.map((item: any, index: number) => <a target={'_self'} href={item.href + (current_language_ch ? '' : '?lan=en')} className={item.is_developing ? 'experience_each top_nav_a_tag_developing' : 'experience_each'} style={{ marginLeft: index % 3 === 0 ? 0 : '4.9%' }} key={index}>
              <img style={{ width: 45, height: 45, marginRight: 5 }} src={item.img} />
              <div>
                <div className='experience_title' style={{ color: '#000000', fontSize: 20, fontFamily: 'PoppinsBold', }}>{current_language_ch ? item.name_ch : item.name_en}</div>
                <div style={{ color: '#000000', fontSize: 16, lineHeight: '20px', marginTop: 3, height: 60 }}>{current_language_ch ? item.remarks_ch : item.remarks_en}</div>
              </div>
            </a>)}
            <div style={{ clear: 'both' }}></div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default App